import { memo } from 'react';
import { connect } from 'react-redux';

import { KNM_STATUS_EXCHANGE } from 'CorePackage/MainModule/routes/routes';
import { IconCheck } from 'UIPackage/IconsModule/components/IconCheck';
import { IconTime } from 'UIPackage/IconsModule/components/IconTime';
import { IKnmWebNotificationInfo } from 'APIPackage/KnmModule/interfaces/IKnmWebNotificationInfo';
import { DATE_FORMAT_LONG_FNS } from 'CorePackage/MainModule/constants/dateFormats';
import { formatDate } from 'CorePackage/MainModule/common/formatDate';
import { Section } from 'UIPackage/FormModule/components/Section';
import { Tooltip } from 'UIPackage/MainModule/components/Tooltip';
import { KnmWebNotificationTypesEnum } from 'APIPackage/KnmModule/enums/KnmWebNotificationTypesEnum';
import { KnmWebNotificationStatusesEnum } from 'APIPackage/KnmModule/enums/KnmWebNotificationStatusesEnum';
import { isLaterThanAdminSetting } from 'CorePackage/MainModule/validators/isLaterThanAdminSetting';
import { AdminSettingCodesEnum } from 'APIPackage/AdminModule/enums/AdminSettingCodesEnum';
import { getAdminFetchSettings } from 'PersonalAccountPackage/AdminModule/selectors/adminSelectors';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { IAdminSetting } from 'APIPackage/AdminModule/interfaces/IAdminSetting';

import styles from './ErknmStatusExchange.module.scss';
import { mapWebNotificationInfoByTitle } from '../constants/mapWebNotificationTypeByTitle';
import { mapWebNotificationStatusByBooleanStatus } from '../constants/mapWebNotificationStatusByBooleanStatus';

interface IErknmStatusExchangeProps {
  data?: IKnmWebNotificationInfo[] | null;
  created: string | undefined;
}

interface IErknmStatusExchangeStoreProps {
  settings: IAdminSetting[] | undefined;
}

const ErknmStatusExchangeWithoutStore = memo(
  ({ data, created, settings }: IErknmStatusExchangeProps & IErknmStatusExchangeStoreProps) => {
    const generateDate = (date: string | null) =>
      date ? formatDate({ date, dateFormat: DATE_FORMAT_LONG_FNS }) : undefined;

    return (
      <Section title='Статус обмена с АИК "Надзор-Web"' id={KNM_STATUS_EXCHANGE}>
        <ul className={styles.StatusExchangeList}>
          {data?.length
            ? data?.map((item, index) => {
                const isProgressExclude =
                  item.status === KnmWebNotificationStatusesEnum.REGISTERED &&
                  item.webNotificationType !== KnmWebNotificationTypesEnum.VP_AGREEMENT;

                const date = generateDate(item.updated || item.created);

                const isOn4131 = isLaterThanAdminSetting(
                  created,
                  settings,
                  AdminSettingCodesEnum.KNM_VALIDATION_4_1_31_STARTS_FROM,
                );

                let titleType = item.webNotificationType;

                if (isOn4131) {
                  if (item.webNotificationType === KnmWebNotificationTypesEnum.VP_AGREEMENT) {
                    titleType = KnmWebNotificationTypesEnum.VP_AGREEMENT_4_1_37;
                  }
                }

                return (
                  <li className={styles.StatusExchangeItem} key={index}>
                    {titleType ? (
                      <>
                        {mapWebNotificationInfoByTitle[titleType]}&nbsp;
                        {date}
                        {item.status &&
                          (mapWebNotificationStatusByBooleanStatus[item.status] || isProgressExclude ? (
                            <Tooltip
                              placement="left"
                              content={
                                <div
                                  className={styles.TooltipContent}
                                >{`Уведомление зарегистрировано под № ${item.caseNumber} от ${date}`}</div>
                              }
                            >
                              <IconCheck className={styles.IconCheck} />
                            </Tooltip>
                          ) : (
                            <Tooltip
                              placement="left"
                              content={
                                <div className={styles.TooltipContent}>
                                  {item.status === KnmWebNotificationStatusesEnum.REGISTERED &&
                                  item.webNotificationType === KnmWebNotificationTypesEnum.VP_AGREEMENT
                                    ? item.caseNumber
                                    : 'В процессе отправки'}
                                </div>
                              }
                            >
                              <IconTime className={styles.Icon} />
                            </Tooltip>
                          ))}
                      </>
                    ) : (
                      'Нет данных о типе взаимодействия'
                    )}
                  </li>
                );
              })
            : 'Нет данных о статусе обмена с АИК "Надзор-Web"'}
        </ul>
      </Section>
    );
  },
);

const mapStateToProps = (state: IRootState): IErknmStatusExchangeStoreProps => ({
  settings: getAdminFetchSettings(state),
});

export const ErknmStatusExchange = connect(mapStateToProps)(ErknmStatusExchangeWithoutStore);
